import QS from 'qs'
var baseURL = 'https://supply.api.fjjykj.com.cn'

export default {
  baseURL: baseURL,
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Abp.TenantId': '1'
  },
  params: {},
  timeout: 10000,
  withCredentials: false,
  responseType: 'json',
  maxContentLength: 2000,
  validateStatus: function (status) {
    return status >= 200 && status <= 500
  },
  maxRedirects: 5,
  transformRequest: [data => JSON.stringify(data)],
  // paramsSerializer: params => JSON.stringify(params),
  data: {}
}



// WEBPACK FOOTER //
// ./src/api/config.js